import { getData, putData } from '../apiClient';

// get SMS configuration
export const getSmsConfig = async () => {
    try {
        const result = await getData("/sms-config/get");
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get SMS config API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// update SMS configuration
export const updateSmsConfig = async ({ data }) => {
    try {
        const result = await putData("/sms-config/update", data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update SMS Config API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};
